import { cva } from "class-variance-authority";

export const alertRootStyle = cva("relative flex min-w-86 flex-wrap gap-3 rounded-lg border p-4 text-sm", {
  variants: {
    type: {
      primary: "border-primary-90 bg-primary-99 text-primary-50",
      secondary: "border-neutral-92 bg-neutral-99 text-neutral-40",
      error: "border-error-87 bg-error-96 text-error-50",
      warning: "border-warning-80 bg-warning-98 text-warning-60",
      success: "border-success-90 bg-success-99 text-success-50",
    },
    orientation: {
      horizontal: "flex-row items-center justify-between",
      vertical: "w-fit max-w-86 flex-col",
    },
  },
  defaultVariants: {
    type: "primary",
    orientation: "vertical",
  },
});

export const alertBadgeTitleStyle = cva(
  "flex w-fit items-center gap-3 rounded-2xl py-1 pr-2.5 pl-1 text-sm font-semibold mix-blend-multiply",
  {
    variants: {
      type: {
        primary: "bg-primary-96 text-primary-50",
        secondary: "bg-neutral-96 text-neutral-30",
        error: "bg-error-94 text-error-50",
        warning: "bg-warning-98 text-warning-60",
        success: "bg-success-98 text-success-50",
      },
    },
    defaultVariants: {
      type: "primary",
    },
  }
);

export const alertBadgeStyle = cva("rounded-2xl bg-white px-2.5 pt-0.5 text-sm font-semibold", {
  variants: {
    type: {
      primary: "text-primary-50",
      secondary: "text-neutral-30",
      error: "text-error-50",
      warning: "text-warning-60",
      success: "text-success-50",
    },
  },
  defaultVariants: {
    type: "primary",
  },
});

export const alertLayoutStyle = cva("flex", {
  variants: {
    orientation: {
      horizontal: "flex-row items-center",
      vertical: "w-fit flex-col",
    },
  },
  defaultVariants: {
    orientation: "vertical",
  },
});

export const alertActionsStyle = cva("text-sm font-semibold", {
  variants: {
    type: {
      primary: "text-primary-40",
      secondary: "text-neutral-40",
      error: "text-error-40",
      warning: "text-warning-50",
      success: "text-success-40",
    },
  },
  defaultVariants: {
    type: "primary",
  },
});
